const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://landingpagecreatorbackend.azurewebsites.net/api';

export const fontsAPI = {
  list: async (websiteId) => {
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/fonts`);
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to load fonts');
    }
    return response.json();
  },

  upload: async (websiteId, file, { family, weight, style } = {}) => {
    const form = new FormData();
    // Append text fields before the file so multer populates req.body for the route.
    if (family) form.append('family', family);
    if (weight) form.append('weight', weight);
    if (style) form.append('style', style);
    form.append('file', file);
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/fonts`, {
      method: 'POST',
      body: form,
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to upload font');
    }
    return response.json();
  },

  remove: async (websiteId, blobName) => {
    const response = await fetch(
      `${API_BASE_URL}/websites/${websiteId}/fonts?blobName=${encodeURIComponent(blobName)}`,
      { method: 'DELETE' }
    );
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to delete font');
    }
    return true;
  },
};
